function IdCell({ hidden, level }) {
    const stringifiedLevel = level.map(item => item + 1).join(".");
    return (
        <td style={{ width: "30px" }}>
            <span className={hidden ? "text-muted cursor" : "cursor"}>
                <i className="fas fa-grip-vertical pe-2"></i>
                {stringifiedLevel}
            </span>
        </td>
    );
}

export default IdCell;